"use client";

import { useUser } from "./use-user";

/**
 * Legacy authentication hook - now uses the unified useUser hook
 * @deprecated Use useUser instead for new code
 */
export function useAuth() {
  return useUser();
}

/**
 * Hook to check if user has specific permissions based on tags
 * @deprecated Use useUser().permissions instead
 */
export function usePermissions() {
  const { permissions, tags, hasTag, hasAnyTag, hasAllTags } = useUser();
  return { ...permissions, tags, hasTag, hasAnyTag, hasAllTags };
}

/**
 * Hook for authentication status checks
 * @deprecated Use useUser() instead
 */
export function useAuthStatus() {
  const { isAuthenticated, isLoading, isUnauthenticated, status, canAccess } =
    useUser();
  return {
    isAuthenticated,
    isLoading,
    isUnauthenticated,
    status,
    requireAuth: () => isAuthenticated,
    canAccess,
  };
}
